import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-12" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table table-responsive-sm table-bordered table-striped table-sm" }
const _hoisted_6 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", null, "대표 이미지"),
    /*#__PURE__*/_createVNode("th", null, "이름"),
    /*#__PURE__*/_createVNode("th", null, "활성상태"),
    /*#__PURE__*/_createVNode("th", null, "순서"),
    /*#__PURE__*/_createVNode("th", null, "상세보기")
  ])
], -1)
const _hoisted_7 = {
  key: 0,
  class: "col-md-3"
}
const _hoisted_8 = {
  key: 1,
  class: "col-md-3"
}
const _hoisted_9 = {
  key: 0,
  class: "badge bg-success text-white"
}
const _hoisted_10 = {
  key: 1,
  class: "badge bg-danger text-white"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("svg", { class: "c-icon c-icon-lg" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-pencil" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: ["card", { loading: _ctx.loading }]
      }, [
        _createVNode("div", _hoisted_3, [
          _createVNode("button", {
            class: "btn btn-primary align-bottom mb-3",
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addRecord()))
          }, " 카테고리 등록 "),
          _createVNode("div", _hoisted_4, [
            _createVNode("table", _hoisted_5, [
              _hoisted_6,
              _createVNode("tbody", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
                  return (_openBlock(), _createBlock("tr", {
                    key: category.data_id
                  }, [
                    (category.thumbnail_url)
                      ? (_openBlock(), _createBlock("td", _hoisted_7, [
                          _createVNode("img", {
                            src: category.thumbnail_url,
                            height: "50"
                          }, null, 8, ["src"])
                        ]))
                      : (_openBlock(), _createBlock("td", _hoisted_8, " 썸네일이미지가 없습니다. ")),
                    _createVNode("td", null, _toDisplayString(category.name), 1),
                    _createVNode("td", null, [
                      (category.is_active)
                        ? (_openBlock(), _createBlock("span", _hoisted_9, "활성"))
                        : (_openBlock(), _createBlock("span", _hoisted_10, "비활성"))
                    ]),
                    _createVNode("td", null, _toDisplayString(category.idx), 1),
                    _createVNode("td", null, [
                      _createVNode("button", {
                        class: "btn btn-btn-warning",
                        disabled: _ctx.loading,
                        type: "button",
                        onClick: ($event: any) => (_ctx.editRecord(category.data_id))
                      }, [
                        _createVNode("span", {
                          class: { 'text-danger': !_ctx.loading }
                        }, [
                          _hoisted_11
                        ], 2)
                      ], 8, ["disabled", "onClick"])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ], 2)
    ])
  ]))
}